import { CrashHandler } from '@enums/crash-handler'

/** The crash title of a rejection whose reason is not an Error, as the Bugfender SDK writes it. */
export const UNHANDLED_REJECTION_TITLE = 'Unhandled promise rejection'
/** The crash title when Angular fails to start and the reason is not an Error. */
export const BOOTSTRAP_FAILED_TITLE = 'The app failed to start'

const NOT_AVAILABLE = 'N/A'

/** The `stack` of whatever was thrown or rejected, when it has one. */
export const errorStack = (error: unknown): unknown =>
	(error as { stack?: unknown } | null | undefined)?.stack

/** A crash ready for `Bugfender.sendCrash`. */
export interface CrashReport {
	readonly title: string
	readonly text: string
}

/**
 * A crash in the exact text the Bugfender SDK 2.4.0 sends from its window listeners, line by line, so crash
 * groups keep their shape whoever caught the failure.
 */
export const crashReport = (
	title: string,
	filename: string | undefined,
	line: number | undefined,
	error: unknown,
	handler: CrashHandler
): CrashReport => {
	const stack = errorStack(error)

	return {
		title,
		text: [
			`Error: ${title}`,
			`URL: ${filename ?? NOT_AVAILABLE}`,
			`Line: ${line ?? NOT_AVAILABLE}`,
			`Handler: ${handler}`,
			`Stack: ${stack || NOT_AVAILABLE}`,
		].join('\n'),
	}
}
